import { render, staticRenderFns } from "./module__form.vue?vue&type=template&id=06d15088"
import script from "./module__form.vue?vue&type=script&lang=js"
export * from "./module__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports